import axios from "axios";
import _ from "lodash";
import initializeAxios from "../util/Axios";

class UserServices {
  constructor() {
    initializeAxios();
  }

  async getUserById(id) {
    const response = await axios.get(`/api/users/id/${id}`);
    return response.data;
  }

  async getCountries() {
    const response = await axios.get("/api/users/countries");
    return response.data;
  }
  async loginAsUser(userId, isAd, adId, endpoint) {
    const params = {
      userId,
    };
    if (_.isEmpty(endpoint) && isAd && adId) {
      params.sellAd = isAd;
      params.sellId = adId;
    }

    if (!_.isEmpty(endpoint) && isAd && adId) {
      params.isAd = isAd;
      params.adId = adId;
      params.endpoint = endpoint;
    }
    const response = await axios.post("/api/users/loginAs", params);
    return response.data;
  }

  async updateUser(query, data) {
    const response = await axios.put("/api/users/update", {
      query,
      data,
    });

    return response.data;
  }

  async getActiveUsers(
    searchTerm,
    businessFilter,
    accountFilter,
    memberFilter,
    countryFilter,
    pageIndex,
    pageSize,
    userFilter,
    fromDate,
    toDate,
    count
  ) {
    try {
      const params = {
        searchTerm: searchTerm || "",
        pageIndex: pageIndex || 0,
        pageSize: pageSize || 100,
        userFilter: userFilter || "all",
        fromDate: fromDate || "",
        toDate: toDate || "",
      };

      if (accountFilter === "free") {
        params.isPremium = false;
      } else if (accountFilter === "paid") {
        params.isPremium = true;
      }

      const response = await axios.get("/api/users", { params });

      return response.data;
    } catch (error) {
      console.error("Error in getActiveUsers:", error);
      console.error("Error response:", error.response);
      if (error.response) {
        console.error("Error response data:", error.response.data);
      }
      throw error;
    }
  }
  async getSellers(filter) {
    const response = await axios.get("/api/reports/sellLog/sellers", {
      params: {
        filter
      }
    });

    return response.data;
  }

  async getUserDetails(id) {
    const response = await axios.get("/api/users/details", {
      params: {
        userId: id
      }
    });
    return response.data;
  }
  
  async deleteUser(id) {
    const response = await axios.put("/api/users/delete", {
      userId: id
    });
    return response.data;
  }
}

export default new UserServices();
